import { LiveUpdate, Story } from '@/lib/types';
import Link from 'next/link';
import Label from '@/components/ui/Label';

export default function LiveFeed({ 
  limit = 4, 
  initialData, 
  livePost 
}: { 
  limit?: number, 
  initialData?: LiveUpdate[], 
  livePost?: Story | null 
}) {
  const updates = initialData ? initialData.slice(0, limit) : [];

  return (
    <div>
      <div className="bg-[#C8102E] px-5 py-3.5 flex items-center gap-3 mb-0">
        <Label type="live" animate />
        <h3 className="font-['Playfair_Display',Georgia,serif] font-bold text-[17px] text-white">
          {livePost ? `${livePost.title}: Live` : 'Live Coverage'}
        </h3>
      </div>
      <div className="border border-[#D4D4D4] border-t-0 divide-y divide-[#D4D4D4]">
        {updates.map((update) => {
          const isPinned = update.type === 'pinned';
          const isAnalyst = update.type === 'analyst';
          const isKeyMoment = update.type === 'keymoment';

          return (
            <div
              key={update.id}
              className={`grid grid-cols-[72px_1fr] divide-x divide-[#D4D4D4] ${
                isPinned ? 'bg-[#FFFBEB] border-l-[3px] border-[#E07B00]' :
                isAnalyst ? 'bg-[#F5F4F0]' :
                isKeyMoment ? 'border-l-[3px] border-[#1A1A1A]' : 'bg-white'
              }`}
            >
              <div className="px-3 py-4 flex flex-col items-center justify-start pt-5">
                <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[13px] text-[#0D0D0D] text-center leading-tight">
                  {update.time}
                </span>
                <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[10px] text-[#6B6B6B] mt-0.5">
                  {update.date}
                </span>
                {isPinned && (
                  <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[9px] text-[#E07B00] uppercase tracking-[0.05em] mt-1">
                    PINNED
                  </span>
                )}
              </div>
              <div className="px-5 py-4">
                {isPinned && (
                  <div className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[10px] tracking-[0.08em] uppercase text-[#E07B00] mb-1.5">
                    📌 Key Development
                  </div>
                )}
                {isAnalyst && (
                  <div className="mb-2">
                    <Label type="analysis" />
                  </div>
                )}
                <h4 className={`font-['Playfair_Display',Georgia,serif] font-bold leading-[1.3] mb-1.5 ${
                  isKeyMoment ? 'text-[19px]' : 'text-[15px]'
                } ${isAnalyst ? 'italic' : ''}`}>
                  {update.headline}
                </h4>
                <p className="font-['Source_Serif_4',Georgia,serif] text-[13px] text-[#2D2D2D] leading-[1.5]">
                  {update.body}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="pt-3">
        <Link
          href="/live"
          className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] text-[#C8102E] hover:text-[#9E0C23] transition-colors"
        >
          View full live feed →
        </Link>
      </div>
    </div>
  );
}
